import {AnimationBaseController, IAnimationControllerConfiguration, Inject} from "@denishussar/html5-game-engine";


export interface IGameEndControllerButtonOptions {
    name: string;
    onClick: (name: string) => void;
}

export class GameEndControllerButton extends AnimationBaseController {
    $model: any;

    public constructor(@Inject private _options: IGameEndControllerButtonOptions) {
        super("GameEndControllerButton");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            childControllers: {},
            onTap: () => {
                this.gotoAndStop("press");
                this._options.onClick(this._options.name);
            },
            onPointerDown: () => {
                this.gotoAndStop("press");
            },
            onPointerOut: () => {
                this.gotoAndStop("active");
            },
            onPointerUpOutside: () => {
                this.gotoAndStop("active")
            },
            onPointerOver: () => {
                this.gotoAndStop("hover")
            },
        };
    }

    protected onInitialize(): void {
    }
}
